import { render } from "./LeaveTypeDetail.vue?vue&type=template&id=a237201e"
import script from "./LeaveTypeDetail.vue?vue&type=script&lang=js"
export * from "./LeaveTypeDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__